import { Dot } from 'lucide-react';
import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    course: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  // handle input change
  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // FINAL WORKING FORM SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const form = new FormData();
      form.append("name", formData.name);
      form.append("email", formData.email);
      form.append("phone", formData.phone);
      form.append("course", formData.course);
      form.append("message", formData.message);

      const response = await fetch("https://formspree.io/f/mrbjpajb", {
        method: "POST",
        body: form,   // IMPORTANT
        headers: {
          "Accept": "application/json",   // Only allowed header
        },
      });

      const data = await response.json();

      if (response.ok) {
        alert("✅ Message sent successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          course: "",
          message: "",
        });
      } else {
        alert("❌ Failed to send message. Try again.");
      }

    } catch (err) {
      console.error(err);
      alert("⚠️ Something went wrong!");
    }

    setLoading(false);
  };

  return (
    <div className="modern-contact-container">
      <div className="orb-background">
        <Dot />
      </div>

      <div className="modern-contact-wrapper">

        {/* Contact Info */}
        <div className="modern-contact-info">
          <h2>📬 Get in Touch</h2>
          <p>Feel free to reach out for any inquiry or collaboration.</p>

          <div className="modern-contact-details">
            <p><strong>Email:</strong> securtech.in@gmail.com</p>
            <p><strong>Phone:</strong> +917314045874</p>
            <p><strong>Phone:</strong> +917400879303</p>
            <p><strong>Phone:</strong> +917223022165</p>
            <p><strong>Location:</strong> Indore, Tower Square</p>
          </div>

          <div className="modern-map-container">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d758.4521670172181!2d75.86466726952052!3d22.69739113595686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3962fce32c33f6c5%3A0x2d8971fcbc729f35!2sShop%20no%203%20shree%2C%20Shree%20Hari%20Gopal%20Complex%2C%20near%20Bhawarkua%20Main%20Road%2C%20Sahid%20Bagat%20Singh%20Colony%2C%20Ashok%20Nagar%2C%20Indore%2C%20Madhya%20Pradesh%20452001!5e1!3m2!1sen!2sin!4v1758257380741!5m2!1sen!2sin"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Contact Form */}
        <form className="modern-contact-form" onSubmit={handleSubmit}>
          <h2>📨 Send a Message</h2>

          <input type="text" name="name" placeholder="Your Name" required value={formData.name} onChange={handleChange} />
          <input type="email" name="email" placeholder="Your Email" required value={formData.email} onChange={handleChange} />
          <input type="tel" name="phone" placeholder="Your Phone Number" required value={formData.phone} onChange={handleChange} />

          <div className="course-selection">
            <p><strong>Select a Course:</strong></p>
            <div id="flexroopconatct">
              <label><input type="radio" name="course" value="CCNA" checked={formData.course === "CCNA"} onChange={handleChange} required /> CCNA</label>
              <label><input type="radio" name="course" value="Ethical Hacking" checked={formData.course === "Ethical Hacking"} onChange={handleChange} /> Ethical Hacking</label>
              <label><input type="radio" name="course" value="CompTIA" checked={formData.course === "CompTIA"} onChange={handleChange} /> CompTIA</label>
              <label><input type="radio" name="course" value="Cyber Security" checked={formData.course === "Cyber Security"} onChange={handleChange} /> Cyber Security</label>
            </div>
          </div>

          <textarea name="message" placeholder="Your Message" rows="5" required value={formData.message} onChange={handleChange}></textarea>

          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
